export default __webpack_public_path__ + "static/media/cancel.b7880c95.png";